let html = `<div class="player-footer">
    <div class="player-footer__body">
        
    </div>
</div>`

export default html